/**
 * @see barramundi/app/Models/MasterCommunicationType.php
 */
export const COMMUNICATION_TYPES = {
    EMAIL: 4,
    SMS: 6
};

export default {
    COMMUNICATION_TYPES
};
